module.exports = __webpack_public_path__ + "static/media/6-rectangle-available.3ebd1274.svg";